import { z } from 'zod/v4';

import { DashboardWidgetIdRuntype, KPIIdRuntype, QuickActionIdRuntype } from './KPIFrontendTypes';

export type DashboardQuickActionDTO = z.infer<typeof DashboardQuickActionDTORuntype>;
export const DashboardQuickActionDTORuntype = z.object({
    id: z.string(),
    url: z.string(),
    label: z.string(),
});

export interface DashboardPreferencesDTO extends z.infer<typeof DashboardPreferencesDTORuntype> {}
export const DashboardPreferencesDTORuntype = z.object({
    dashboard_kpis: z.array(KPIIdRuntype),
    dashboard_widgets: z.array(DashboardWidgetIdRuntype),
    dashboard_quick_actions: z.array(QuickActionIdRuntype),
});
